import { axios } from '@/utils/request'

const api = {
    saiquList: '/wyhadminapi/sai/saiquList',
    saiquCashList: '/wyhadminapi/sai/saiquCashList',
    cashDetail: '/wyhadminapi/sai/saiRewardDetail',
    cashEdit: '/wyhadminapi/sai/saiRewardEdit',
    sjsqOptions: '/wyhadminapi/sai/sjsqOptions',

    saiquDetail: '/wyhadminapi/sai/saiquDetail',
    editSaiqu: '/wyhadminapi/sai/editSaiqu',
    onSaiReward: '/wyhadminapi/sai/onSaiReward',
    addSaiqu: '/wyhadminapi/sai/addSaiqu',

    saijiList: '/wyhadminapi/sai/saijiList',
    saijiDetail: '/wyhadminapi/sai/saijiDetail',
    editSaiji: '/wyhadminapi/sai/editSaiji',

    danweiList: '/wyhadminapi/sai/danweiList',
    danweiOptions: '/wyhadminapi/sai/danweiOptions',
    danweiDetail: '/wyhadminapi/sai/danweiDetail',
    editDanwei: '/wyhadminapi/sai/editDanwei',
    danweiDelete: '/wyhadminapi/sai/danweiDelete',
    danweiUserList: '/wyhadminapi/sai/danweiUserList',
    addDanweiUser: '/wyhadminapi/sai/addDanweiUser', 
    deleteDanweiUser: '/wyhadminapi/sai/deleteDanweiUser',

    applyList: '/wyhadminapi/sai/applyList',
    applyDetail: '/wyhadminapi/sai/applyDetail',
    editApply: '/wyhadminapi/sai/editApply',
    getApplyOrderDetail: '/wyhadminapi/sai/applyOrderDetail',
    editApplyOrder: '/wyhadminapi/sai/editApplyOrder',
    refreshOrder: '/wyhadminapi/sai/refreshOrder',

    applySubjectList: '/wyhadminapi/sai/applySubjectList',
    applySubjectDetail: '/wyhadminapi/sai/applySubjectDetail',
    editApplySubject: '/wyhadminapi/sai/editApplySubject',

    subjectOptions: '/wyhadminapi/sai/subjectOptions',
    downloadAllCpCert: '/adminapi/sai/downloadAllCpCert',
    downloadAllJlCert: '/adminapi/sai/downloadAllJlCert',
    downloadAllLdCert: '/adminapi/sai/downloadAllLdCert',
    downloadAllCert: '/adminapi/sai/downloadAllCert',

    applyDelete: '/wyhadminapi/sai/applyDelete',
    getStartList: '/wyhadminapi/sai/getStartList',
    startListOptions: '/wyhadminapi/sai/startListOptions',
    caipanList: '/wyhadminapi/sai/caipanList',
    jiaolianList: '/wyhadminapi/sai/jiaolianList',
    lingduiList: '/wyhadminapi/sai/lingduiList',


    subjectMusicList: '/wyhadminapi/sai/subjectMusicList',
    subjectMusicDetail: '/wyhadminapi/sai/subjectMusicDetail',
    editSubjectMusic: '/wyhadminapi/sai/editSubjectMusic',
    addSubjectMusic: '/wyhadminapi/sai/addSubjectMusic',
    subjectMusicDelete: '/wyhadminapi/sai/subjectMusicDelete',



    subjectTypeList: '/wyhadminapi/sai/subjectTypeList',
    subjectTypeDetail: '/wyhadminapi/sai/subjectTypeDetail',
    editSubjectType: '/wyhadminapi/sai/editSubjectType',
    addSubjectType: '/wyhadminapi/sai/addSubjectType',
    subjectTypeDelete: '/wyhadminapi/sai/subjectTypeDelete',


    subjectMemberLimitList: '/wyhadminapi/sai/subjectMemberLimitList',
    setSubjectMemberLimit: '/wyhadminapi/sai/setSubjectMemberLimit',
    setSubjectAgeLimit: '/wyhadminapi/sai/setSubjectAgeLimit',

    subject2MusicList: '/wyhadminapi/sai/subject2MusicList',
    setSubjectMusicLimit: '/wyhadminapi/sai/setSubjectMusicLimit',
    setSubjectMusic: '/wyhadminapi/sai/setSubjectMusic',
    setSubjectsMusic: '/wyhadminapi/sai/setSubjectsMusic',
    getSubjectTypeOptions: '/wyhadminapi/sai/subjectTypeOptions',
    subjectDelete: '/wyhadminapi/sai/subjectDelete',


    getSaiDateDetail: '/wyhadminapi/sai/getSaiDateDetail',
    getTaskDetail: '/wyhadminapi/sai/getTaskDetail',
    taskEdit: '/wyhadminapi/sai/taskEdit',

    addSaiquApply: '/wyhadminapi/sai/addSaiquApply',
    editSaiquApply: '/wyhadminapi/sai/editSaiquApply',
    getSaiquApplyList: '/wyhadminapi/sai/saiquApplyList',
    getSaiquApplyDetail: '/wyhadminapi/sai/saiquApplyDetail',
    editDo: '/wyhadminapi/sai/editDo',


    addSaiFile: '/wyhadminapi/sai/filesadd',
    saiFileList: '/wyhadminapi/sai/fileslist',
    deleteSaiFile: '/wyhadminapi/sai/filesdelete',


    subjectTreeList: '/wyhadminapi/sai/subjectTreeList',
    subjectTplTreeList: '/wyhadminapi/sai/subjectTplTreeList',
    saveSubjectTree: '/wyhadminapi/sai/saveSubjectTree',


    getXieyiList: '/wyhadminapi/sai/xieyiList',
    addXieyiFile: '/wyhadminapi/sai/addXieyiFile',
    saiquApplyDelete: '/wyhadminapi/sai/saiquApplyDelete',



    roomTypeList: '/wyhadminapi/sai/roomTypeList',
    roomTypeDetail: '/wyhadminapi/sai/roomTypeDetail',
    addRoomType: '/wyhadminapi/sai/addRoomType',
    editRoomType: '/wyhadminapi/sai/editRoomType',
    roomTypeDelete: '/wyhadminapi/sai/roomTypeDelete',

    //酒店
    hotelList: '/wyhadminapi/sai/hotelList',
    hotelDetail: '/wyhadminapi/sai/hotelDetail',
    addHotel: '/wyhadminapi/sai/addHotel',
    editHotel: '/wyhadminapi/sai/editHotel',
    hotelDelete: '/wyhadminapi/sai/hotelDelete',

    //交通
    busList: '/wyhadminapi/sai/busList',
    busDetail: '/wyhadminapi/sai/busDetail',
    addBus: '/wyhadminapi/sai/addBus',
    editBus: '/wyhadminapi/sai/editBus',
    busDelete: '/wyhadminapi/sai/busDelete',

    //站点
    stationList: '/wyhadminapi/sai/stationList',
    stationDetail: '/wyhadminapi/sai/stationDetail',
    addStation: '/wyhadminapi/sai/addStation',
    editStation: '/wyhadminapi/sai/editStation',
    stationDelete: '/wyhadminapi/sai/stationDelete',



    getConfrimApplyList: '/wyhadminapi/sai/confrimApplyList',
    getTransApplyList: '/wyhadminapi/sai/transApplyList',
    setConfrimStatus: '/wyhadminapi/sai/setConfrimStatus',
    editTrans: '/wyhadminapi/sai/editTrans',

    hotelOptions: '/wyhadminapi/sai/hotelOptions',
    setHotel: '/wyhadminapi/sai/setHotel',
    unSetHotel: '/wyhadminapi/sai/unSetHotel',
    busgetImport: '/wyhadminapi/sai/busgetImport',
    busgoImport: '/wyhadminapi/sai/busgoImport',

    orderRefund: '/wyhadminapi/sai/orderRefund',
    orderRefundApply: '/wyhadminapi/sai/orderRefundApply',
    orderRefundRefuse: '/wyhadminapi/sai/orderRefundRefuse',


    //执行官
    zhixingguanList: '/wyhadminapi/sai/zhixingguanList',
    zhixingguanDetail: '/wyhadminapi/sai/zhixingguanDetail',
    addZhixingguan: '/wyhadminapi/sai/addZhixingguan',
    editZhixingguan: '/wyhadminapi/sai/editZhixingguan',
    zhixingguanDelete: '/wyhadminapi/sai/zhixingguanDelete',


    saiquXieyiDelete: '/wyhadminapi/sai/xieyiDelete',


    //裁判库

    memberCaipanList: '/wyhadminapi/sai/memberCaipanList',
    memberCaipanDetail: '/wyhadminapi/sai/memberCaipanDetail',
    editMemberCaipan: '/wyhadminapi/sai/editMemberCaipan',
    addMemberCaipan: '/wyhadminapi/sai/addMemberCaipan',
    memberCaipanDelete: '/wyhadminapi/sai/memberCaipanDelete',
    setYouxiu: '/wyhadminapi/sai/setYouxiu',

}

export default api

export function getSaijiList(parameter) {
    return axios({
        url: api.saijiList,
        method: 'get',
        params: parameter
    })
}

export function getSaijiDetail(parameter) {
    return axios({
        url: api.saijiDetail,
        method: 'get',
        params: parameter
    })
}

export function editSaiji(parameter) {
    return axios({
        url: api.editSaiji,
        method: 'post',
        data: parameter
    })
}



export function getSaiquList(parameter) {
    return axios({
        url: api.saiquList,
        method: 'get',
        params: parameter
    })
}
export function getSaiquCashList(parameter) {
    return axios({
        url: api.saiquCashList,
        method: 'get',
        params: parameter
    })
}

export function getSaiquDetail(parameter) {
    return axios({
        url: api.saiquDetail,
        method: 'get',
        params: parameter
    })
}

export function editSaiqu(parameter) {
    return axios({
        url: api.editSaiqu,
        method: 'post',
        data: parameter
    })
}

export function onSaiReward(parameter) {
    return axios({
        url: api.onSaiReward,
        method: 'post',
        data: parameter
    })
}


export function addSaiqu(parameter) {
    return axios({
        url: api.addSaiqu,
        method: 'post',
        data: parameter
    })
}

export function getDanweiList(parameter) {
    return axios({
        url: api.danweiList,
        method: 'get',
        params: parameter
    })
}

export function getDanweiOptions(parameter) {
    return axios({
        url: api.danweiOptions,
        method: 'get',
        params: parameter
    })
}

export function getDanweiDetail(parameter) {
    return axios({
        url: api.danweiDetail,
        method: 'get',
        params: parameter
    })
}
export function editDanwei(parameter) {
    return axios({
        url: api.editDanwei,
        method: 'post',
        data: parameter
    })
}
export function danweiDelete(parameter) {
    return axios({
        url: api.danweiDelete,
        method: 'post',
        data: parameter
    })
}


export function getApplyList(parameter) {
    return axios({
        url: api.applyList,
        method: 'get',
        params: parameter
    })
}

export function getApplyDetail(parameter) {
    return axios({
        url: api.applyDetail,
        method: 'get',
        params: parameter
    })
}
export function editApply(parameter) {
    return axios({
        url: api.editApply,
        method: 'post',
        data: parameter
    })
}



export function getApplySubjectList(parameter) {
    return axios({
        url: api.applySubjectList,
        method: 'get',
        params: parameter
    })
}

export function applySubjectDetail(parameter) {
    return axios({
        url: api.applySubjectDetail,
        method: 'get',
        params: parameter
    })
}
export function editApplySubject(parameter) {
    return axios({
        url: api.editApplySubject,
        method: 'post',
        data: parameter
    })
}


export function applyDelete(parameter) {
    return axios({
        url: api.applyDelete,
        method: 'post',
        data: parameter
    })
}


export function subjectOptions(parameter) {
    return axios({
        url: api.subjectOptions,
        method: 'get',
        params: parameter
    })
}
export function downloadAllCpCert(parameter) {
    return axios({
        url: api.downloadAllCpCert,
        method: 'get',
        params: parameter
    })
}

export function downloadAllJlCert(parameter) {
    return axios({
        url: api.downloadAllJlCert,
        method: 'get',
        params: parameter
    })
}

export function downloadAllLdCert(parameter) {
    return axios({
        url: api.downloadAllLdCert,
        method: 'get',
        params: parameter
    })
}

export function downloadAllCert(parameter) {
    return axios({
        url: api.downloadAllCert,
        method: 'get',
        params: parameter
    })
}
export function startListOptions(parameter) {
    return axios({
        url: api.startListOptions,
        method: 'get',
        params: parameter
    })
}
export function getStartList(parameter) {
    return axios({
        url: api.getStartList,
        method: 'get',
        params: parameter
    })
}
export function getLingduiList(parameter) {
    return axios({
        url: api.lingduiList,
        method: 'get',
        params: parameter
    })
}
export function getJiaolianList(parameter) {
    return axios({
        url: api.jiaolianList,
        method: 'get',
        params: parameter
    })
}
export function getCaipanList(parameter) {
    return axios({
        url: api.caipanList,
        method: 'get',
        params: parameter
    })
}
export function subjectMusicList(parameter) {
    return axios({
        url: api.subjectMusicList,
        method: 'get',
        params: parameter
    })
}
export function subjectMusicDetail(parameter) {
    return axios({
        url: api.subjectMusicDetail,
        method: 'get',
        params: parameter
    })
}
export function editSubjectMusic(parameter) {
    return axios({
        url: api.editSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function addSubjectMusic(parameter) {
    return axios({
        url: api.addSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function subjectMusicDelete(parameter) {
    return axios({
        url: api.subjectMusicDelete,
        method: 'post',
        params: parameter
    })
}


export function subjectTypeList(parameter) {
    return axios({
        url: api.subjectTypeList,
        method: 'get',
        params: parameter
    })
}
export function subjectTypeDetail(parameter) {
    return axios({
        url: api.subjectTypeDetail,
        method: 'get',
        params: parameter
    })
}
export function editSubjectType(parameter) {
    return axios({
        url: api.editSubjectType,
        method: 'post',
        data: parameter
    })
}
export function addSubjectType(parameter) {
    return axios({
        url: api.addSubjectType,
        method: 'post',
        data: parameter
    })
}
export function subjectTypeDelete(parameter) {
    return axios({
        url: api.subjectTypeDelete,
        method: 'post',
        params: parameter
    })
}



export function getSubjectMemberLimitList(parameter) {
    return axios({
        url: api.subjectMemberLimitList,
        method: 'get',
        params: parameter
    })
}
export function setSubjectMemberLimit(parameter) {
    return axios({
        url: api.setSubjectMemberLimit,
        method: 'post',
        data: parameter
    })
}
export function setSubjectAgeLimit(parameter) {
    return axios({
        url: api.setSubjectAgeLimit,
        method: 'post',
        data: parameter
    })
}
export function getSubjectMusicList(parameter) {
    return axios({
        url: api.subject2MusicList,
        method: 'get',
        params: parameter
    })
}
export function setSubjectMusic(parameter) {
    return axios({
        url: api.setSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function setSubjectsMusic(parameter) {
    return axios({
        url: api.setSubjectsMusic,
        method: 'post',
        data: parameter
    })
}
export function getSubjectTypeOptions(parameter) {
    return axios({
        url: api.getSubjectTypeOptions,
        method: 'get',
        params: parameter
    })
}
export function sjsqOptions(parameter) {
    return axios({
        url: api.sjsqOptions,
        method: 'get',
        params: parameter
    })
}
export function getApplyOrderDetail(parameter) {
    return axios({
        url: api.getApplyOrderDetail,
        method: 'get',
        params: parameter
    })
}
export function editApplyOrder(parameter) {
    return axios({
        url: api.editApplyOrder,
        method: 'post',
        data: parameter
    })
}
export function subjectDelete(parameter) {
    return axios({
        url: api.subjectDelete,
        method: 'post',
        data: parameter
    })
}
export function refreshOrder(parameter) {
    return axios({
        url: api.refreshOrder,
        method: 'post',
        data: parameter
    })
}


export function getSaiDateDetail(parameter) {
    return axios({
        url: api.getSaiDateDetail,
        method: 'post',
        data: parameter
    })
}
export function getTaskDetail(parameter) {
    return axios({
        url: api.getTaskDetail,
        method: 'post',
        data: parameter
    })
}
export function taskEdit(parameter) {
    return axios({
        url: api.taskEdit,
        method: 'post',
        data: parameter
    })
}
export function addSaiquApply(parameter) {
    return axios({
        url: api.addSaiquApply,
        method: 'post',
        data: parameter
    })
}
export function editSaiquApply(parameter) {
    return axios({
        url: api.editSaiquApply,
        method: 'post',
        data: parameter
    })
}
export function getSaiquApplyList(parameter) {
    return axios({
        url: api.getSaiquApplyList,
        method: 'get',
        params: parameter
    })
}
export function getSaiquApplyDetail(parameter) {
    return axios({
        url: api.getSaiquApplyDetail,
        method: 'get',
        params: parameter
    })
}
export function editDo(parameter) {
    return axios({
        url: api.editDo,
        method: 'post',
        data: parameter
    })
}



export function addSaiFile(parameter) {
    return axios({
        url: api.addSaiFile,
        method: 'post',
        data: parameter
    })
}

export function getSaiFileList(parameter) {
    return axios({
        url: api.saiFileList,
        method: 'get',
        params: parameter
    })
}

export function deleteSaiFile(parameter) {
    return axios({
        url: api.deleteSaiFile,
        method: 'post',
        data: parameter
    })
}


export function subjectTreeList(parameter) {
    return axios({
        url: api.subjectTreeList,
        method: 'get',
        params: parameter
    })
}

export function subjectTplTreeList(parameter) {
    return axios({
        url: api.subjectTplTreeList,
        method: 'get',
        params: parameter
    })
}
export function saveSubjectTree(parameter) {
    return axios({
        url: api.saveSubjectTree,
        method: 'post',
        data: parameter
    })
}



export function addXieyiFile(parameter) {
    return axios({
        url: api.addXieyiFile,
        method: 'post',
        data: parameter
    })
}
export function getXieyiList(parameter) {
    return axios({
        url: api.getXieyiList,
        method: 'post',
        data: parameter
    })
}



export function getRoomTypeList(parameter) {
    return axios({
        url: api.roomTypeList,
        method: 'get',
        params: parameter
    })
}


export function addRoomType(parameter) {
    return axios({
        url: api.addRoomType,
        method: 'post',
        data: parameter
    })
}

export function editRoomType(parameter) {
    return axios({
        url: api.editRoomType,
        method: 'post',
        data: parameter
    })
}
export function getRoomTypeDetail(parameter) {
    return axios({
        url: api.roomTypeDetail,
        method: 'get',
        params: parameter
    })
}

export function roomTypeDelete(parameter) {
    return axios({
        url: api.roomTypeDelete,
        method: 'post',
        data: parameter
    })
}


//酒店


export function getHotelList(parameter) {
    return axios({
        url: api.hotelList,
        method: 'get',
        params: parameter
    })
}


export function addHotel(parameter) {
    return axios({
        url: api.addHotel,
        method: 'post',
        data: parameter
    })
}

export function editHotel(parameter) {
    return axios({
        url: api.editHotel,
        method: 'post',
        data: parameter
    })
}
export function getHotelDetail(parameter) {
    return axios({
        url: api.hotelDetail,
        method: 'get',
        params: parameter
    })
}

export function hotelDelete(parameter) {
    return axios({
        url: api.hotelDelete,
        method: 'post',
        data: parameter
    })
}

//交通

export function getBusList(parameter) {
    return axios({
        url: api.busList,
        method: 'get',
        params: parameter
    })
}


export function addBus(parameter) {
    return axios({
        url: api.addBus,
        method: 'post',
        data: parameter
    })
}

export function editBus(parameter) {
    return axios({
        url: api.editBus,
        method: 'post',
        data: parameter
    })
}
export function getBusDetail(parameter) {
    return axios({
        url: api.busDetail,
        method: 'get',
        params: parameter
    })
}

export function busDelete(parameter) {
    return axios({
        url: api.busDelete,
        method: 'post',
        data: parameter
    })
}


//站点

export function getStationList(parameter) {
    return axios({
        url: api.stationList,
        method: 'get',
        params: parameter
    })
}


export function addStation(parameter) {
    return axios({
        url: api.addStation,
        method: 'post',
        data: parameter
    })
}

export function editStation(parameter) {
    return axios({
        url: api.editStation,
        method: 'post',
        data: parameter
    })
}
export function getStationDetail(parameter) {
    return axios({
        url: api.stationDetail,
        method: 'get',
        params: parameter
    })
}

export function stationDelete(parameter) {
    return axios({
        url: api.stationDelete,
        method: 'post',
        data: parameter
    })
}

export function setConfrimStatus(parameter) {
    return axios({
        url: api.setConfrimStatus,
        method: 'post',
        data: parameter
    })
}

export function getConfrimApplyList(parameter) {
    return axios({
        url: api.getConfrimApplyList,
        method: 'get',
        params: parameter
    })
}

export function getTransApplyList(parameter) {
    return axios({
        url: api.getTransApplyList,
        method: 'get',
        params: parameter
    })
}


export function editTrans(parameter) {
    return axios({
        url: api.editTrans,
        method: 'post',
        data: parameter
    })
}

export function hotelOptions(parameter) {
    return axios({
        url: api.hotelOptions,
        method: 'get',
        params: parameter
    })
}
export function setHotel(parameter) {
    return axios({
        url: api.setHotel,
        method: 'post',
        data: parameter
    })
}
export function unSetHotel(parameter) {
    return axios({
        url: api.unSetHotel,
        method: 'post',
        data: parameter
    })
}
export function busgetImport(parameter) {
    return axios({
        url: api.busgetImport,
        method: 'post',
        headers: {
            'Content-Type':'multipart/form-data'
        },
        data: parameter
    })
}
export function busgoImport(parameter) {
    return axios({
        url: api.busgoImport,
        method: 'post',
        headers: {
            'Content-Type':'multipart/form-data'
        },
        data: parameter
    })
}
export function saiquApplyDelete(parameter) {
    return axios({
        url: api.saiquApplyDelete,
        method: 'post',
        data: parameter
    })
}
export function saiquXieyiDelete(parameter) {
    return axios({
        url: api.saiquXieyiDelete,
        method: 'post',
        data: parameter
    })
}

export function orderRefund(parameter) {
    return axios({
        url: api.orderRefund,
        method: 'post',
        data: parameter
    })
}

export function orderRefundApply(parameter) {
    return axios({
        url: api.orderRefundApply,
        method: 'get',
        params: parameter
    })
}

export function orderRefundRefuse(parameter) {
    return axios({
        url: api.orderRefundRefuse,
        method: 'get',
        params: parameter
    })
}

//执行官

export function getZhixingguanList(parameter) {
    return axios({
        url: api.zhixingguanList,
        method: 'get',
        params: parameter
    })
}


export function addZhixingguan(parameter) {
    return axios({
        url: api.addZhixingguan,
        method: 'post',
        data: parameter
    })
}

export function editZhixingguan(parameter) {
    return axios({
        url: api.editZhixingguan,
        method: 'post',
        data: parameter
    })
}
export function getZhixingguanDetail(parameter) {
    return axios({
        url: api.zhixingguanDetail,
        method: 'get',
        params: parameter
    })
}

export function zhixingguanDelete(parameter) {
    return axios({
        url: api.zhixingguanDelete,
        method: 'post',
        data: parameter
    })
}




//裁判库
export function memberCaipanList(parameter) {
    return axios({
        url: api.memberCaipanList,
        method: 'get',
        params: parameter
    })
}
export function memberCaipanDetail(parameter) {
    return axios({
        url: api.memberCaipanDetail,
        method: 'get',
        params: parameter
    })
}
export function editMemberCaipan(parameter) {
    return axios({
        url: api.editMemberCaipan,
        method: 'post',
        data: parameter
    })
}
export function addMemberCaipan(parameter) {
    return axios({
        url: api.addMemberCaipan,
        method: 'post',
        data: parameter
    })
}
export function memberCaipanDelete(parameter) {
    return axios({
        url: api.memberCaipanDelete,
        method: 'post',
        params: parameter
    })
}


export function getDanweiUserList(parameter) {
    return axios({
        url: api.danweiUserList,
        method: 'get',
        params: parameter
    })
}

export function deleteDanweiUser(parameter) {
    return axios({
        url: api.deleteDanweiUser,
        method: 'post',
        data: parameter
    })
}

export function addDanweiUser(parameter) {
    return axios({
        url: api.addDanweiUser,
        method: 'post',
        data: parameter
    })
}

export function setYouxiu(parameter) {
    return axios({
        url: api.setYouxiu,
        method: 'post',
        data: parameter
    })
}

export function getCashDetail(parameter) {
    return axios({
        url: api.cashDetail,
        method: 'post',
        data: parameter
    })
}

export function cashEdit(parameter) {
    return axios({
        url: api.cashEdit,
        method: 'post',
        data: parameter
    })
}
